import { Suspense, lazy } from 'react'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

const JobsListPage = lazy(() => import('@/pages/jobs/list'))

export default function EventsListPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <Suspense fallback={null}>
        <JobsListPage portalMode="event" />
      </Suspense>
    </WorkspacePortalProvider>
  )
}
